<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="deptId" label="区域" :rules="[{ required: true, message: '请选择' }]" >
        <!-- <CustomerAreaCascader
          appId="cos_lbu"
          deptInfoId="3853844"
          :disabled="editForm.id"
          v-model:value="editForm.deptId"
          v-model:label="editForm.deptName"
        /> -->
        <CosCascader
          placeholder="请选择"
          :options="deptInfo4List"
          :fieldNames="{ label: 'label', value: 'id', children: 'children' }"
          appId="cos_lbu"
          :disabled="editForm.id"
          v-model:value="editForm.deptId"
          v-model:label="editForm.deptName"
        />
      </a-form-item>
      <a-form-item name="deptManager" label="查看人" :rules="[{ required: true, message: '请选择' }]" >
        <user-select v-model:value="editForm.deptManager" allowClear mode="multiple" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, onMounted } from 'vue'
import type { FormInstance } from 'ant-design-vue'
import { DcMessage } from '@dc-platform/dc-components'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { getDeptInfo } from '@/api/common'
import {
  createRegionSetting,
  updateRegionSetting
} from '@/api/yuntuSales/regionSetting'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref({})
const emit = defineEmits(['success'])
const deptInfo4List = ref([])

const fetchDeptInfo = async () => {
  const res = await getDeptInfo({ appId: 'cos_lbu', rootId: '3853844' })
  deptInfo4List.value = res.data?.deptInfo[0]?.children
  deptInfo4List.value.forEach((item: any) => {
    if (item.children && item.children.length) {
      item.children.forEach((o: any) => {
        if (o.children) delete o.children
      })
    }
  })
}
const toggle = (row?: any) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = { ...editForm.value }
    if (p.deptName) {
      p.deptName = p.deptName.split('/').pop()
    }
    try {
      if (editForm.value.id) {
        await updateRegionSetting(p)
      } else {
        await createRegionSetting(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}

onMounted(() => {
  fetchDeptInfo()
})


defineExpose({
  toggle
})
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  align-items: center;
  .title-span {
    font-weight: 500;
    color: red;
    font-size: 14px;
  }
}
</style>
